import { render } from "./OverLapImage.vue?vue&type=template&id=553b4a48&ts=true"
import script from "./OverLapImage.vue?vue&type=script&lang=ts"
export * from "./OverLapImage.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__